function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Divider } from '../../components/dataDisplay/Divider';
import { Box } from '../../components/internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var GroupDivider = _ref => {
  var {
    isVertical
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    as: props => /*#__PURE__*/_jsx(Divider, _objectSpread(_objectSpread({}, props), {}, {
      variant: isVertical ? 'vertical' : 'horizontal'
    })),
    alignSelf: "stretch",
    height: isVertical ? 'auto' : void 0,
    flexGrow: 0,
    "data-component": "GroupDivider"
  });
};
GroupDivider.displayName = 'GroupDivider';
//# sourceMappingURL=GroupDivider.js.map